export default [
  {
    path: '/entity-log',
    name: 'PageEntityLog',
    meta: {
      title: 'entityLog.listTitle',
      roles: ['ADMIN'],
      permissions: ['offer_log_view', 'partner_log_view', 'offer_partner_log_view'],
    },
    component: () => import('@/pages/entity-logs'),
  },
]
